import { Button } from "react-bootstrap"
import { useNavigate } from "react-router-dom"

const Failure = () => {
  const navigate = useNavigate()

  const handleRetryPayment = async () => {
    navigate("/payments")
  }

  return (
    <div>
      <div
        className="d-flex flex-column align-items-center text-center">
        <h1 className="text-danger mb-4 mt-5">Payment Issue</h1>
        <p className="mb-2">There was an issue processing your payment. <br/> If funds were deducted from your account,
          they will be automatically refunded within 5-7 business days.</p>
        <Button variant="dark" className="mt-4 rounded-3 px-5" onClick={handleRetryPayment}>
          Try Again
        </Button>
      </div>
    </div>
  )
}
export default Failure